const HEADLINER_GRADIENT_COLOR_1 = '#5dbefc';
const HEADLINER_GRADIENT_COLOR_2 = '#dd92fe';

export function headlinerGradient(angle: number) {
  return `linear-gradient(${angle}deg, ${HEADLINER_GRADIENT_COLOR_1}, ${HEADLINER_GRADIENT_COLOR_2})`;
}
